import { ConfigurationService } from './services/Common/configuration.service';
import { EndpointFactory } from './endpoints/endpoint-factory.service';
import { LocalStoreManager } from './services/Common/local-store-manager.service';
import { NgModule, ModuleWithProviders, APP_INITIALIZER , Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { StoreModule } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { IonicStorageModule } from '@ionic/storage';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './app.effects';
import * as fromStore from './store';
import { RoleGuard } from './guards/role.guard';
import {services, AuthTokenFactory, AuthTokenService, TokenInterceptor, AuthService} from '@app/core/services';
import { throwIfAlreadyLoaded } from './guards/module-import.guard';
import { AuthenticationEndpoint } from './endpoints/authentication-endpoint.service';
import { CsrfInterceptor } from './services/interceptors/csrfheader.interceptor';
import { AuthorizeGuard } from './guards/authorize.guard';
import { AuthorizeInterceptor } from './authorization/authorize.interceptor';
import { ApiAuthorizationModule } from './authorization/api-authorization.module';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    // HotkeysModule.forRoot(),
    ApiAuthorizationModule,
    StoreModule.forRoot(fromStore.reducers, {
      metaReducers: fromStore.metaReducers
    }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    EffectsModule.forRoot([...fromStore.effects, AppEffects])
  ],
  exports: [],
  providers: [
    AuthorizeGuard,
    RoleGuard,
    ...services,
    ...fromStore.services,
    ConfigurationService,
    LocalStoreManager,
    EndpointFactory,
    AuthenticationEndpoint,
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: AuthTokenFactory,
    //   deps: [AuthTokenService],
    //   multi: true
    // },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: TokenInterceptor,
    //   multi: true
    // },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: CsrfInterceptor,
    //   multi: true
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizeInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
